/* SpeakOut contact form. When the section has an endpoint URL, submit the
   fields as JSON to it (the speakout-contact Worker) instead of Shopify's
   native contact form. With no endpoint, this script only validates and the
   form submits natively. If the endpoint cannot deliver, it falls back to the
   native submit so no message is lost. */
(function () {
  function init(root) {
    if (root.dataset.contactReady) return;
    root.dataset.contactReady = '1';
    var form = root.querySelector('form');
    if (!form) return;
    var endpoint = (root.dataset.endpoint || '').trim();
    var started = Date.now();
    var errorBox = root.querySelector('[data-contact-error]');
    var success = root.querySelector('[data-contact-success]');
    var button = root.querySelector('[data-contact-submit]');
    var label = root.querySelector('[data-contact-submit-label]');
    var idleLabel = label ? label.textContent : '';

    function field(key) { return form.querySelector('[data-key="' + key + '"]'); }
    function val(key) { var el = field(key); return el ? el.value.trim() : ''; }

    function validate() {
      var bad = [];
      form.querySelectorAll('[data-key]').forEach(function (el) {
        el.removeAttribute('aria-invalid');
        if ((el.required && !el.value.trim()) || !el.checkValidity()) bad.push(el);
      });
      var email = field('email');
      if (email && email.value && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) bad.push(email);
      bad.forEach(function (el) { el.setAttribute('aria-invalid', 'true'); });
      if (bad.length) bad[0].focus();
      return bad.length === 0;
    }

    function blockInvalid(e) {
      if (validate()) return false;
      e.preventDefault();
      e.stopImmediatePropagation();
      return true;
    }

    window.addEventListener('click', function (e) {
      var submitter = e.target.closest && e.target.closest('button, input[type="submit"], input[type="image"]');
      if (!submitter || submitter.form !== form || !['submit', 'image'].includes(submitter.type)) return;
      blockInvalid(e);
    }, true);

    form.addEventListener('invalid', function (e) {
      e.target.setAttribute('aria-invalid', 'true');
    }, true);

    form.addEventListener('input', function (e) {
      if (e.target.matches('[data-key]') && e.target.value.trim() && e.target.checkValidity()) {
        e.target.removeAttribute('aria-invalid');
      }
    });

    var submit = form.submit.bind(form);
    form.submit = function () {
      if (validate()) return submit();
    };

    function busy(on) {
      if (!button) return;
      button.disabled = on;
      button.classList.toggle('is-busy', on);
      if (label) label.textContent = on ? (button.dataset.busyLabel || idleLabel) : idleLabel;
    }

    window.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (blockInvalid(e)) return;
      if (!endpoint) return; // native Shopify submit
      e.preventDefault();
      e.stopImmediatePropagation();
      if (errorBox) errorBox.hidden = true;
      busy(true);
      var tokenEl = form.querySelector('[name="cf-turnstile-response"]');
      var payload = {
        name: val('name'), email: val('email'), phone: val('phone'), topic: val('topic'),
        order: val('order'), message: val('message'), website: val('website'),
        elapsed_ms: Date.now() - started, page: location.href,
        turnstile_token: tokenEl ? tokenEl.value : ''
      };
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok && d.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw res.d;
          form.hidden = true;
          if (success) { success.hidden = false; success.focus(); }
        })
        .catch(function (d) {
          // The endpoint could not deliver (email provider down or not yet
          // verified, network error). Fall back to Shopify's native contact
          // submit so the message still reaches the store contact email.
          var undeliverable = !d || !d.error || d.error === 'send_failed';
          if (undeliverable && !form.dataset.nativeFallback) {
            form.dataset.nativeFallback = '1';
            endpoint = '';
            busy(false);
            setTimeout(function () {
              if (validate()) form.requestSubmit(button);
            }, 0);
            return;
          }
          busy(false);
          if (d && d.fields) Object.keys(d.fields).forEach(function (k) { var el = field(k); if (el) el.setAttribute('aria-invalid', 'true'); });
          if (errorBox) errorBox.hidden = false;
          if (window.turnstile && window.turnstile.reset) try { window.turnstile.reset(); } catch (_) {}
        });
    }, true);
  }
  function all() { document.querySelectorAll('[data-speakout-contact]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
